import axios from 'axios'

import { getCookie } from '@/utils/cookie'
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 12000000
})
var host_url = window.location.host
var index = host_url.indexOf('.')
host_url = host_url.slice(0, index)
// 发版使用该配置
sessionStorage.setItem('schema', host_url)
// 本地使用该配置
// sessionStorage.setItem('schema', 'dev')
// sessionStorage.setItem('schema', 'h5dev')
// sessionStorage.setItem('schema', 'h5cbc')

// 本地连接线上正式库看效果使用该配置
// sessionStorage.setItem('schema', 'h5')
// sessionStorage.setItem('schema', 'cac')
request.interceptors.request.use(
  (success) => {
    success.headers.schema = sessionStorage.getItem('schema')
    if (getCookie('token')) {
      success.headers.token = getCookie('token')
      success.headers.language = sessionStorage.getItem('language')
    } else {
      success.headers.token = ''
      success.headers.language = sessionStorage.getItem('language')
    }
    return success
  },
  (err) => {
    return err
  }
)

export default request
